module.exports = __webpack_public_path__ + "static/cashback-banner-5-21de3deed74faa01bf8de6296462347c.png";